import { Fragment, FunctionComponent, useState } from "react";

import MainButton from "~/components/common/mainButton";
import Modal from "~/components/ui/modal";
import { useAuth } from "~/contexts/providers/auth";
import { useLanguage } from "~/contexts/providers/language";
import englishTranslations from "~/localization/en";
import frenchTranslations from "~/localization/fr";

import styles from "./loginSection.module.scss";
import UpdatePassword from "./UpdatePassword";

const AccountLoginSection: FunctionComponent = () => {
  const [modal, setModal] = useState(false);
  const { language } = useLanguage();

  const { user } = useAuth();

  const loginFormTexts =
    language === "En"
      ? englishTranslations.accountPage.loginForm
      : frenchTranslations.accountPage.loginForm;
  const accountTexts =
    language === "En"
      ? englishTranslations.accountPage
      : frenchTranslations.accountPage;
  const handleModal = () => {
    setModal(!modal);
  };
  return (
    <div className={styles.loginSectionContainer}>
      <h5 className="small-title">{accountTexts.personalInformation}</h5>
      <fieldset>
        <legend>{loginFormTexts.legend}</legend>
        <Fragment>
          <label className={styles.label}>{loginFormTexts.username}</label>
          <input
            type="email"
            placeholder={loginFormTexts.username}
            size={14}
            disabled={true}
            readOnly={true}
            defaultValue={user?.username}
          />
          <label className={styles.label}>{loginFormTexts.password}</label>
          <input
            type="password"
            placeholder="********"
            size={14}
            disabled={true}
            readOnly={true}
            defaultValue={user?.username}
          />
          <br />
          <MainButton onClick={handleModal} style={{ textTransform: "none" }}>
            {loginFormTexts.update}
          </MainButton>
        </Fragment>
      </fieldset>
      <Modal
        open={modal}
        onClose={() => {
          setModal(false);
        }}
        blur
      >
        <UpdatePassword
          handleClose={() => {
            setModal(false);
          }}
        />
      </Modal>
    </div>
  );
};

export default AccountLoginSection;
